import React from 'react'
import { MuiTypography,MuiToolTip, MuiGrid, MuiDialogActions, MuiInfoIcon, MuiDialogContent, MuiDialogTitle, MuiButton, MuiDialog, MuiFileCopyOutlinedIcon, MuiIconButton, muiWithStyles } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme'
function ShareTimeTableDialog(props) {


    const { classes, i18n } = props;
    const ttLinkDataMap = [
        {key:"6guD0dyp",label: i18n.weeklyTimeTable.teacherTimeTableLink},
        {key:"CV6Z5P2c",label:i18n.weeklyTimeTable.groupTimeTableLink},
        {key:"GYrHI5Cj",label:i18n.weeklyTimeTable.roomTimeTableLink}
        // MASTER_SCHEDULE: {key:"mYZkdhB0",label:"Teacher TimeTable Link"
    ]
    const renderLink=(type)=>{
        let baseUrl=window.location.origin
        let link=baseUrl+'/timeTableView/'+props.schedule.timeTableDetails['_id']+'/'+type.key
        return(<MuiGrid container xs={12} >
        <MuiGrid  xs={12} >
        <MuiTypography  variant={theme.typographyStyles.BODY} gutterBottom>
            {type.label}
        </MuiTypography></MuiGrid>
        <MuiGrid container xs={12} style={{marginBottom:8}} alignItems='center' justify='center'>
        <MuiGrid   xs>
            <MuiTypography  variant={theme.typographyStyles.BODY} style={{border:'1px solid '+theme.palette.primary.main,padding:8,wordWrap: 'break-word' }}>
                {link}
                </MuiTypography></MuiGrid>
                <MuiGrid >
                    <MuiToolTip title= {i18n.commonTexts.copyToClipBoard} arrow>
                    <MuiIconButton>
                    <MuiFileCopyOutlinedIcon color='primary' onClick={()=>{navigator.clipboard.writeText(link)}}></MuiFileCopyOutlinedIcon></MuiIconButton>
                    </MuiToolTip>
        </MuiGrid>
                </MuiGrid>
        </MuiGrid>)
    } 
    return (
        <MuiDialog
            open={props.open}
            onClose={() => props.cancel()} >
            <MuiDialogTitle style={{ background: theme.palette.grey.dark }} >
                <MuiGrid container>
                    <MuiGrid item xs container alignItems="center" justify="center" >
                        <MuiTypography style={{ fontFamily: "Arial", fontSize: '15px', color: "white" }}>
                        {i18n.weeklyTimeTable.shareTimeTable} - {props.schedule.name}
                        </MuiTypography>
                    </MuiGrid>

                    <MuiGrid item container alignItems="center" justify="center" xs={1} >
                        <MuiButton >
                            <MuiInfoIcon style={{ color: "white" }} size="small" />
                        </MuiButton>
                    </MuiGrid>
                </MuiGrid>
            </MuiDialogTitle>
            <MuiDialogContent>
            {ttLinkDataMap.map((type)=>renderLink(type))}
            </MuiDialogContent>

            <MuiDialogActions>
                <MuiGrid container spacing={2} align="center" justify='flex-end'>

                    <MuiGrid item >
                        <MuiButton

                            style={theme.secondaryButtonStyle}
                            onClick={
                                props.cancel
                            }>
                            {i18n.commonTexts.cancel}
                        </MuiButton>
                    </MuiGrid>

                </MuiGrid>
            </MuiDialogActions>

        </MuiDialog>
    )


}
const elementClassNames = theme => ({

    cancelButton: {
        width: "117px",
        borderRadius: "30px",
        textTransform: "none",
        border: `1px solid ${theme.palette.secondary[300]}`,
        [theme.breakpoints.down('xs')]: { width: "150px" }
    },
    dialogActionGrid: { height: "5vh" },

})

export default muiWithStyles(elementClassNames)(ShareTimeTableDialog);